import React, { useState } from 'react';
import clsx from 'clsx';
import Social from '../../../../components/social/social';
import PropTypes from 'prop-types';

const BottomNav = ({
  tabs,
  activeTab,
  setActiveTab,
  year,
  socialShareText
}) => {
  const [socialIsOpen, setSocialIsOpen] = useState(false);

  const handleTabClick = idx => {
    if (activeTab !== idx) {
      let topOfList = document?.querySelector('section.list-container');
      let location = 0;

      if (topOfList?.offsetParent) {
        do {
          location += topOfList?.offsetTop;
          topOfList = topOfList?.offsetParent;
        } while (topOfList);
      }

      (() => window?.scrollTo({ top: location - 90, behavior: 'smooth' }))();
      setActiveTab(idx);
    }
  };

  return (
    <nav className={clsx(['bottom-nav'])}>
      {tabs.map((tab, idx) => (
        <div
          className={clsx(['tab', activeTab === idx && 'active'])}
          onClick={() => handleTabClick(idx)}
          key={`tab-${idx}`}
        >
          {tab}
        </div>
      ))}

      <div className={clsx(['social-container'])}>
        <ShareIcon setSocialIsOpen={setSocialIsOpen} />
        {socialIsOpen && (
          <Social
            modifier="bottom-nav"
            disableStyle={true}
            uri={`https://www.fastcompany.com/innovation-by-design/${year}`}
            text={socialShareText}
          />
        )}
      </div>
    </nav>
  );
};

const ShareIcon = ({ setSocialIsOpen }) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={() => setSocialIsOpen(o => !o)}
  >
    <g id="share icon">
      <path
        id="share-icon-explore-v3"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.36328 12.6024C2.80265 12.6025 2.26505 12.38 1.8684 11.9837C1.47189 11.5875 1.24901 11.05 1.24887 10.4895C1.24872 9.92895 1.47116 9.39129 1.86736 8.99485C2.26358 8.59841 2.80117 8.37542 3.36181 8.37516C3.92229 8.37488 4.46018 8.59728 4.85669 8.99341C5.25335 9.38956 5.47633 9.92692 5.47678 10.4875C5.47663 11.048 5.25391 11.5855 4.85769 11.9821C4.46133 12.3787 3.92388 12.6016 3.36324 12.6024H3.36328ZM16.6141 14.9988C17.1748 14.9988 17.7124 15.2215 18.1087 15.6178C18.5052 16.0139 18.728 16.5515 18.7281 17.112C18.7283 17.6724 18.5057 18.21 18.1095 18.6065C17.7131 19.0029 17.1757 19.2258 16.615 19.226C16.0545 19.2262 15.5168 19.0038 15.1201 18.6078C14.7236 18.2116 14.5006 17.6743 14.5002 17.1137C14.5003 16.553 14.7231 16.0154 15.1194 15.6188C15.5158 15.2224 16.0534 14.9993 16.6142 14.9989L16.6141 14.9988ZM16.6141 1.75166C17.1749 1.75166 17.7127 1.97449 18.1091 2.37094C18.5055 2.76738 18.7282 3.30504 18.7281 3.86568C18.7279 4.42637 18.5051 4.96403 18.1084 5.36032C17.7118 5.75661 17.174 5.97916 16.6133 5.97886C16.0525 5.97857 15.5149 5.7556 15.1185 5.35903C14.7223 4.96244 14.4999 4.42453 14.5002 3.86399C14.5009 3.30375 14.7238 2.76668 15.1201 2.37068C15.5165 1.97468 16.0538 1.75195 16.6141 1.75166ZM16.6141 7.22439C17.56 7.22453 18.4623 6.82636 19.0996 6.12748C19.7369 5.42861 20.0504 4.49366 19.963 3.55194C19.8757 2.61006 19.3957 1.74868 18.6409 1.17892C17.8859 0.609025 16.9259 0.38346 15.9961 0.55736C15.0663 0.731395 14.2527 1.28878 13.755 2.09301C13.2573 2.89724 13.1214 3.87394 13.3805 4.78357L6.03822 8.45355C5.46649 7.70212 4.60511 7.22568 3.66455 7.14088C2.72411 7.05595 1.79133 7.37048 1.09421 8.00732C0.397098 8.64429 0 9.54485 0 10.489C0 11.4332 0.397061 12.3337 1.09421 12.9707C1.79133 13.6075 2.72414 13.922 3.66455 13.8371C4.60514 13.7523 5.46653 13.2759 6.03822 12.5245L13.3805 16.1944C13.0685 17.2818 13.3221 18.4531 14.0559 19.3142C14.7899 20.1752 15.9064 20.6112 17.0297 20.4756C18.153 20.3399 19.1335 19.6505 19.6412 18.6396C20.1488 17.6286 20.1161 16.4305 19.5539 15.4488C18.9918 14.4671 17.9751 13.8321 16.8461 13.758C15.7172 13.6838 14.626 14.1802 13.9403 15.0799L6.59649 11.4073C6.7681 10.8072 6.7681 10.1709 6.59649 9.57079L13.9403 5.89823C14.5752 6.73386 15.5644 7.22472 16.6141 7.22472L16.6141 7.22439Z"
        fill="black"
      />
    </g>
  </svg>
);

BottomNav.propTypes = {
  tabs: PropTypes.shape([]).isRequired,
  activeTab: PropTypes.number.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  year: PropTypes.number.isRequired,
  socialShareText: PropTypes.string.isRequired
};

ShareIcon.propTypes = {
  setSocialIsOpen: PropTypes.func.isRequired
};

export default BottomNav;
